import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  color: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M19 9A7 7 0 1 1 5 9a7 7 0 0 1 14 0"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8 15v5.513c0 .874 0 1.312.276 1.45.277.139.626-.123 1.324-.648l1.2-.902c.578-.435.867-.652 1.2-.652s.622.217 1.2.652l1.2.902c.698.524 1.047.787 1.324.648.276-.138.276-.576.276-1.45V15M11.669 5.212a.365.365 0 0 1 .662 0l.814 1.668c.054.11.155.187.273.207l1.768.294c.3.05.42.434.205.658l-1.266 1.326a.4.4 0 0 0-.104.335l.279 1.85c.047.314-.266.551-.536.407l-1.595-.849a.36.36 0 0 0-.338 0l-1.595.849c-.27.144-.583-.093-.536-.407l.279-1.85a.4.4 0 0 0-.104-.335L8.609 8.04c-.214-.224-.095-.608.205-.658l1.768-.294a.37.37 0 0 0 .273-.207z"
    }, null, -1)
  ]))]))
}
export default { render: render }